import i18next from "i18next"

import { catchError, getError, http } from "services/http"
import { ErrorResponse } from "models"

const getConsumer = async (consumerId: string, mode: string) => {
    const getConsumerErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                switch (error?.message) {
                    case "Operation is not allowed: role.":
                    case "Operation is not allowed: wallet.":
                        return { code: error?.code, message: i18next.t("sell_error_NotAuthorizedException", { ns: "api" }) }
                    default:
                        return { code: error?.code, message: i18next.t("sell_error_default", { ns: "bike" }) }
                }
            case "ConsumerNotFoundException":
            case "MoonCodeNotFoundException":
                return { code: error?.code, message: i18next.t("sell_error_ConsumerNotFoundException", { ns: "api" }) }
            case "ExpiredShortCodeIdException":
                return { code: error?.code, message: i18next.t("sell_error_ExpiredShortCodeIdException", { ns: "bike" }) }
            case "InvalidArgument":
                return { code: error?.code, message: i18next.t("search_error_InvalidArgument", { ns: "api" }) }
            case "EntityStatusException":
                return { code: error?.code, message: i18next.t("sell_error_NotAuthorizedException", { ns: "api" }) }
            default:
                return { code: error?.code, message: i18next.t("sell_error_default", { ns: "bike" }) }
        }
    }
    
    let param = ""
    switch (mode) {
        case "byOcodeId":
            param = `ocode_id=${consumerId}`
            break
        case "byShortCodeId":
            param = `short_code_id=${consumerId}`
            break
        default:
            param = `ocode_id=${consumerId}`
            break
    }

    const res = await http
        .get(`obikeapi/auth_store/consumer?${param}`, {})
        .catch(e => catchError(e))

    return {
        res,
        getError: getError(res, getConsumerErrors)
    }
}

export { getConsumer }
